const VARIANTS = {
  success: "bg-emerald-50 text-emerald-600",
  warning: "bg-amber-50 text-amber-600",
  danger: "bg-red-50 text-red-600",
  info: "bg-blue-50 text-blue-600",
  gray: "bg-gray-100 text-gray-600",
};

export default function Badge({ variant = "gray", children }) {
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${VARIANTS[variant]}`}>
      {children}
    </span>
  );
}
